import { render, staticRenderFns } from "./paymentResult.vue?vue&type=template&id=150f1a3b&"
import script from "./paymentResult.vue?vue&type=script&lang=js&"
export * from "./paymentResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports